<template>
	<span class="content">
		<Username :user="message.from" />
		<i class="hostmask"></i>
		<template v-if="message.account">
			<i class="account"> [{{ message.account }}]</i>
		</template>
			sapo hyri ne kanal
	</span>
</template>

<script>
import ParsedMessage from "../ParsedMessage.vue";
import Username from "../Username.vue";

export default {
	name: "MessageTypeJoin",
	components: {
		ParsedMessage,
		Username,
	},
	props: {
		network: Object,
		message: Object,
	},
};
</script>
